// ===== FIXED USE AUTH HOOK =====
// src/hooks/useAuth.js
import { useContext } from "react";
import AuthContext from "../contexts/AuthContext";

export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }

  return context;
};

// Additional auth-related hooks
export const usePermissions = () => {
  const { permissions, hasPermission, hasAllPermissions, hasAnyPermission } =
    useAuth();

  return {
    permissions,
    hasPermission,
    hasAllPermissions,
    hasAnyPermission,
  };
};

export const useRole = () => {
  const { user, hasRole, hasAnyRole } = useAuth();

  return {
    role: user?.role,
    hasRole,
    hasAnyRole,
  };
};

export const useActivityTracker = () => {
  const { updateActivity } = useAuth();

  // Track user activity on various events
  const trackActivity = () => {
    updateActivity();
  };

  return { trackActivity };
};
